export const getPrimaryCdsLocation = (
  locations?:
    | {
        name: string;
        primary: boolean;
      }[]
    | null
) =>
  locations
    ? locations.find((location) => location.primary) || locations[0]
    : undefined;
